<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <div class="title">
      <h6>OAuth2 Interface Configuration</h6>
      <span class="status body-1" [class.green-color]="data?.oAuth2Enabled">{{
        data?.oAuth2Enabled ? 'Enabled' : 'Disabled'
      }}</span>
    </div>

    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />

<div mat-dialog-content class="oAuth-interface">
  <form [formGroup]="oAuthForm">
    <div class="fields-container">
      <mat-form-field class="disable">
        <mat-label>client_id</mat-label>
        <input formControlName="clientId" matInput disabled />
      </mat-form-field>

      <mat-form-field>
        <mat-label>client_secret</mat-label>
        <input formControlName="clientSecret" matInput required />
        @if (clientSecret.hasError('required')) {
          <mat-error> client_secret is <strong>required</strong> </mat-error>
        }
      </mat-form-field>
    </div>
    <mat-form-field>
      <mat-label>redirect_uri</mat-label>
      <input formControlName="redirectUri" matInput required />
      @if (redirectUri.hasError('required')) {
        <mat-error>redirect_uri is <strong>required</strong></mat-error>
      }
      @if (!redirectUri.valid && !isProd() && !redirectUri.hasError('required')) {
        <mat-error>Please enter valid <strong>redirect_uri</strong></mat-error>
      }
      @if (!redirectUri.valid && isProd() && !redirectUri.hasError('required')) {
        <mat-error>Protocol should be <strong>https</strong></mat-error>
      }
    </mat-form-field>
  </form>
</div>
<mat-divider class="mx-20!" />

<mat-dialog-actions>
  <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
  <button
    matButton="text"
    [disabled]="(clientSecret.invalid || redirectUri.invalid) && !data?.oAuth2Enabled"
    (click)="confirmChangeStatusOfInterface(data?.oAuth2Enabled)">
    {{ data?.oAuth2Enabled ? 'DISABLE' : 'ENABLE' }}
  </button>
  <button
    matButton="elevated"
    class="red-button"
    [disabled]="oAuthForm.invalid || oAuthForm.pristine || pending()"
    (click)="updateQuotingSystemOauth2()">
    SAVE
  </button>
</mat-dialog-actions>
